import "./Footer.scss";

import { Facebook, Logo } from "../../assets/svg/svgIcons";
import { SOCIAL_LINKS } from "../../config/socials";

const Footer = () => {
  return (
    <section className="footer">
      <Logo className="footerLogo" />
      <div className="footerText">
        <p>© 2026 4x4vert</p>
      </div>
      <div className="footerIcons">
        <Facebook
          className="facebook"
          onClick={() => window.open(SOCIAL_LINKS.facebook)}
        />
      </div>
    </section>
  );
};

export default Footer;
